import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { Button, FormControlLabel, Switch, Box, Typography } from "@mui/material";
import { api } from "../../../../api/api";
import useAxios from "../../../../api/useAxios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../../../redux/bodyPart/bodyPartSlice";
import ImageDropZone from "../../../common/ImageDropZone";
const BodyPartCreateModal = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [update, setUpdate] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const instance = useAxios();
  const [error, setError] = useState({
    name: {
      message: "",
    },
  });
  const bodyPartData = useSelector((state) => state.bodyPart?.data);
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    const name = formJson.name;

    if (name.trim().length === 0) {
      setError({ name: { message: "Name is required" } });
      return;
    }

    const data = new FormData();
    data.append("name", name);
    data.append("isUsed", active);
    data.append("canUpdate", update);
    if (photo) {
      data.append("photo", photo);
    }

    setIsLoading(true);
    try {
      const res = await instance.post("body-part", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setIsLoading(false);
      const newData = [res.data?.data, ...bodyPartData];

      dispatch(setData(newData));

      // setData(res.data.data);

      Swal.fire({
        title: "Success",
        text: res.data.message,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (e) {
      setIsLoading(false);
      Swal.fire({
        title: "Error",
        text: "Something Went Wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
      console.log(e);
    }

    handleClose();
  };
  return (
    <>
      <Button size="small" variant="contained" onClick={handleClickOpen}>
        Add Bodypart
      </Button>
      <Dialog
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: { width: "500px" },
        }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Create Body Part</DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <form onSubmit={handleSubmit} id="subscription-form">
            <TextField
              autoFocus
              margin="dense"
              id="name"
              name="name"
              label="Name"
              type="text"
              fullWidth
              error={error?.name?.message}
              helperText={error?.name?.message}
              variant="standard"
            />

            <FormControlLabel
              sx={{ mt: 3 }}
              label="Active"
              control={
                <Switch
                  checked={active}
                  onChange={(e) => setActive(e.target.checked)}
                />
              }
            />

            <FormControlLabel
              sx={{ mt: 3 }}
              label="Update"
              control={
                <Switch
                  disabled={!active}
                  checked={update}
                  onChange={(e) => setUpdate(e.target.checked)}
                />
              }
            />

            <Box className="mt-4 mb-2">
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500, color: "text.secondary", display: 'block' }}>
                Photo (Optional)
              </Typography>
              <ImageDropZone
                file={photo}
                onFileSelect={(file) => setPhoto(file)}
                onFileRemove={() => setPhoto(null)}
                label="Photo"
              />
            </Box>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" form="subscription-form">
            {isLoading ? "Loading ..." : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BodyPartCreateModal;
